import { motion } from "framer-motion";
import { Lock, Shield, WifiOff, Smartphone } from "lucide-react";

export default function PrivacyViz() {
  return (
    <div className="relative w-[70%] md:w-full aspect-[4/5] max-w-[520px] mx-auto">
      {/* Halo */}
      <div
        aria-hidden
        className="absolute inset-10 rounded-full bp-glow"
        style={{ opacity: 0.9 }}
      />

      {/* Central shield */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 flex items-center justify-center"
      >
        <div className="relative">
          <div
            className="absolute inset-0 rounded-[36%] bp-pulse"
            style={{
              background:
                "radial-gradient(circle, rgba(0,250,248,0.4), transparent 60%)",
              filter: "blur(30px)",
            }}
          />
          <svg width="240" height="270" viewBox="0 0 240 270">
            <defs>
              <linearGradient id="shieldStroke" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#00FAF8" />
                <stop offset="1" stopColor="#00FAF8" stopOpacity="0.4" />
              </linearGradient>
              <linearGradient id="shieldFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#1E293B" />
                <stop offset="1" stopColor="#0F172A" />
              </linearGradient>
            </defs>
            <path
              d="M120 10 L220 46 L220 138 C220 200 175 240 120 260 C65 240 20 200 20 138 L20 46 Z"
              fill="url(#shieldFill)"
              stroke="url(#shieldStroke)"
              strokeWidth="1.4"
            />
            {/* Inner concentric */}
            <path
              d="M120 40 L192 66 L192 138 C192 190 158 220 120 236 C82 220 48 190 48 138 L48 66 Z"
              fill="none"
              stroke="rgba(0,250,248,0.15)"
              strokeWidth="1"
            />
            {/* Lock icon area */}
            <g transform="translate(84 108)">
              <rect x="0" y="18" width="72" height="52" rx="12" fill="rgba(0,250,248,0.12)" stroke="rgba(0,250,248,0.4)" />
              <path d="M14 18 V10 C14 -4 58 -4 58 10 V18" fill="none" stroke="rgba(0,250,248,0.6)" strokeWidth="2" />
              <circle cx="36" cy="42" r="4" fill="#00FAF8" />
              <line x1="36" y1="42" x2="36" y2="54" stroke="#00FAF8" strokeWidth="2" strokeLinecap="round" />
            </g>
          </svg>
        </div>
      </motion.div>

      {/* Orbiting chips */}
      <FloatingChip
        icon={<WifiOff size={12} className="text-[#00FAF8]" />}
        label="Offline First"
        pos="top-4 left-2"
        delay={0.2}
      />
      <FloatingChip
        icon={<Smartphone size={12} className="text-[#00FAF8]" />}
        label="Primär lokal"
        pos="top-8 right-4"
        delay={0.4}
      />
      <FloatingChip
        icon={<Lock size={12} className="text-[#00FAF8]" />}
        label="Clientseitig verschlüsselt"
        pos="bottom-16 left-0"
        delay={0.6}
      />
      <FloatingChip
        icon={<Shield size={12} className="text-[#00FAF8]" />}
        label="Zero-Knowledge Backup"
        pos="bottom-6 right-2"
        delay={0.8}
      />
    </div>
  );
}

function FloatingChip({ icon, label, pos, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ delay, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`absolute ${pos} flex items-center gap-2 rounded-full border border-white/10 bg-[#0F172A]/85 backdrop-blur px-3 py-1.5`}
    >
      {icon}
      <span className="text-[11px] font-mono-bp text-white/85 whitespace-nowrap">
        {label}
      </span>
    </motion.div>
  );
}
